export default __webpack_public_path__ + "static/media/fruit-1024w.d47c4f92.avif";